import React from "react";
import Banner from "../../Components/FieldDays/Banner/Banner";
import BannerVideo from "../../Components/FieldDays/BannerVideo/BannerVideo";
import FieldDaysSection from "../../Components/FieldDays/FieldDaysSection/FieldDaysSection";
import ChoosePlans from "../../Components/FieldDays/ChoosePlans/ChoosePlans";
import Activity from "../../Components/FieldDays/Activity/Activity";
import FDE from "../../Components/FieldDays/FDE/FDE";
import "./style.css";
import SEO from "../../Components/SEO";
export default function FieldDays() {
  console.log(window.matchMedia("(prefers-color-scheme: light)").matches);
  return (
    <div className="fieldDays-container">
      <SEO
        title="BWC Sports | Field Days"
        description=""
        url="https://bwcsports.com/field-days"
      />
      <Banner />
      <BannerVideo />
      <FieldDaysSection />
      <ChoosePlans />
      <Activity />
      <FDE />
    </div>
  );
}
